import { useEffect, useState } from "react";

// true mientras la pantalla cumple la consulta (p. ej. "(min-width: 1024px)"); se actualiza al girar o cambiar el tamaño
export const useMedia = (query) => {
  const [on, setOn] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const fn = () => setOn(m.matches);
    fn();
    m.addEventListener("change", fn);
    return () => m.removeEventListener("change", fn);
  }, [query]);
  return on;
};
